import React, { useEffect, useState } from 'react'
import { height, width } from '../Card/CardStyles';
import DynamicCard from '../DynamicCard';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import CalendarIcon from '../../../assets/images/calendar_icon.png';
import PayperksPoints from '../../../assets/images/payperks_points.png';
import { useDispatch, useSelector } from 'react-redux';
import { GET_PAYPERKS_DASHBOARD, GET_PAY_PERKS_API, STATUS_SUCCESS_CODE } from '../../../network/URLConstants';
import { GetApiHeadersWithBearer, GetRequest, PostRequest } from '../../../network/NetworkUtils';
import { appTheme } from '../../../helpers/utils/Utils';
import { retrieveData } from '../../../utils';
import logFirebaseEvents from '../../LogFirebaseEvents';

const PayPerks = ({Radius, isCardRadius}) => {

  const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue);
  const appThemeData = appTheme(kudzuPlusTrue)

  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const appConfigData = useSelector(state => state.appConfigData);
  const cards = useSelector(state => JSON.parse(state.userCards));
  const payperksDays = useSelector(state => state.payperksDays);
  const [pendingDaysToSweep, setpendingDaysToSweep] = useState('');
  const [pointBalance, setpointBalance] = useState('');
  const [isOpted, setisOpted] = useState(false);
  const accessTokenToApi = useSelector(state => state.accessToken);

  const getPayperksDetails = async () => {
    if (cards == undefined || cards == null) {
      return
    }
    const deviceId = await retrieveData('updatedDeviceId');
    let headers = await GetApiHeadersWithBearer(deviceId, accessTokenToApi);

    let url = GET_PAY_PERKS_API(cards[0].CardKey) + '&version=' + appConfigData.APP_VERSION + '&isDarkMode=true';
    const response = await GetRequest(url, headers)
    let responseObj = JSON.parse(response);
    if (responseObj.ResponseCode == STATUS_SUCCESS_CODE) {
      const payperksURL = { payperksURL: responseObj.Response.URL }
      dispatch({ type: 'PAYPERKS_DASHBOARD_URL', payload: payperksURL });
      GetPayperkDashboardDetails(responseObj.Response.AuthToken, cards[0].CardKey)
    } else {
      // PAYPERKS_ERROR
      const arrMessages = responseObj.Messages;
      const message = arrMessages[0];
      const displayText = message.DisplayText;

      const payperksError = { payperksError: displayText }
      dispatch({ type: 'PAYPERKS_ERROR', payload: payperksError });
    }
  }

  const GetPayperkDashboardDetails = async (authToken, cardKey) => {
    if (cardKey == undefined) {
      return
    }

    const deviceId = await retrieveData('updatedDeviceId');
    let headers = await GetApiHeadersWithBearer(deviceId, accessTokenToApi);

    var obj = { "authToken": authToken };
    let finalUrl = GET_PAYPERKS_DASHBOARD(cardKey)
    const response = await PostRequest(finalUrl, obj, headers)
    var parsedResponse = JSON.parse(response)
    if (parsedResponse.ResponseCode == STATUS_SUCCESS_CODE) {
      if (parsedResponse.Response != null) {
        const payperksDays = { payperksDays: parsedResponse.Response.PendingDaysToSweep.toString().length == 1 ? "0" + parsedResponse.Response.PendingDaysToSweep.toString() : parsedResponse.Response.PendingDaysToSweep.toString() }
        dispatch({ type: 'PAYPERKS_DAYS', payload: payperksDays });

        setpendingDaysToSweep(parsedResponse.Response.PendingDaysToSweep.toString().length == 1 ? "0" + parsedResponse.Response.PendingDaysToSweep.toString() : parsedResponse.Response.PendingDaysToSweep.toString());
        setpointBalance(parsedResponse.Response.Profile != null ? parsedResponse.Response.Profile.PointBalance : 0);
        setisOpted(parsedResponse.Response.Profile != null ? parsedResponse.Response.Profile.IsOpted : false);
      } else {
        const payperksError = { payperksError: t('something_went_wrong') }
        dispatch({ type: 'PAYPERKS_ERROR', payload: payperksError });
      }
    } else {
      const arrMessages = parsedResponse.Messages;
      const message = arrMessages[0];
      const displayText = message.DisplayText;
      const payperksError = { payperksError: displayText }
      dispatch({ type: 'PAYPERKS_ERROR', payload: payperksError });
    }
  }

  useEffect(() => {
    getPayperksDetails()
  }, [])

  return (
    <DynamicCard header={true}
      footer={true} isHome={true} cardHeight={height.perks_profile}
      cardWidth={width.homeCard} isPerk={true} HeaderRadius={Radius} Radiusnone={true}
      CardRadius={Radius} isCardRadius={isCardRadius}>
      <div className='md:py-20 sm:py-12 py-16 relative'>
        {isOpted ?
          <>
            <div className=' sm:flex sm:flex-row sm:justify-between sm:items-start md:px-16 sm:px-[2.5rem] px-6 '>
              <div className=' flex flex-col '>
                <div className=' flex flex-row justify-between items-start'>
                  <div className='flex items-center gap-3'>
                    <img src={appThemeData.Homepayperks} className='hidden sm:block w-[43px] h-[26px]' alt="" />
                    <div className="font-serif-pro sm:font-hanken-grotesk text-[var(--payperks-heading-text)] lg:w-[205px] md:w-[177px] sm:w-[138px]
                  w-[200px] 
                sm:text-[14px] text-[26px]
                font-normal sm:font-[600] sm:leading-[100%] sm:tracking-[0.1em] sm:uppercase pb-8 sm:pb-0">
                      {t('NavbarPerks')}
                    </div>
                  </div>

                <img src={appThemeData.Homepayperks} className=' flex sm:hidden mt-2 w-[70px] h-[43px]' alt="" />
 
                </div>
                <p className='hidden sm:block font-hanken-grotesk font-[400] lg:text-[18px] md:text-[16px] sm:text-[14px] leading-[26px] text-[var(--payperks-body-text-color)] mt-[20px] lg:w-[400px] md:w-[350px] sm:w-[280px] whitespace-nowrap mb-[40px]'>
                  {t('payperks_sweepstakes_desc')}
                </p>
                <hr className='hidden sm:block w-full border-t-[2.5px] border-[#A3CEBB] opacity-50 mb-[40px]' />
                <div className=' flex flex-col md:flex-row '>
                  {/* box1 */}
                  <div className='flex flex-col justify-center items-center md:pr-10 border-[#A3CEBB] border-b-4 md:border-b-0'>
                    <div className=' flex flex-row justify-start items-start gap-2 md:gap-4 w-full sm:w-[240px] md:w-auto'>
                      <img src={CalendarIcon} alt='arrow' className=' md:w-[20px] md:h-[18px] sm:w-[17px] sm:h-[16px] w-[16px] h-[15px] md:mt-0 sm:mt-4 mt-5' />
                      <div className='flex flex-row md:flex-col justify-between md:justify-center items-start w-full gap-4 md:gap-0'>
                        <p className=' font-hanken-grotesk text-[var(--payperks-body-text-color)] sm:text-[20px] sm:font-[600] sm:leading-[100%] sm:tracking-[0%] md:text-[20px] md:font-[600] text-[16px] font-[600] mt-4 md:mt-0 w-1/3 sm:w-1/2 md:w-auto'>{t("nxt_sweep")}</p>
                        <div className=' flex flex-row gap-4 items-end justify-end w-2/3 sm:w-1/2 md:w-auto'>
                          <p className=' font-hanken-grotesk text-[var(--payperks-body-text-color)] sm:text-[72px] sm:font-[600] sm:leading-[100%] sm:tracking-[0%] sm:align-middle sm:mt-[12px] p-0 text-[56px] font-[600] tracking-wider '>
                            {pendingDaysToSweep}
                          </p>
                          <p className=' font-hanken-grotesk text-[var(--payperks-body-text-color)] md:text-[20px] md:font-[700] sm:text-[12px] sm:font-[700] text-[16px] font-[700] pb-8 sm:pb-0'>
                            {t("days")}
                          </p>
                        </div>

                      </div>
                    </div>
                  </div>
                  {/* box2 */}
                  <div className='flex flex-col justify-center items-center md:pl-10 border-0 '>
                    <div className=' flex flex-row justify-start items-start gap-2 md:gap-4 w-full sm:w-[240px] md:w-auto'>
                      <img src={PayperksPoints} alt='arrow' className=' md:w-[20px] md:h-[20px] sm:w-[17px] sm:h-[17px] w-[16px] h-[16px] md:mt-0 sm:mt-4 mt-5' />
                      <div className='flex flex-row md:flex-col justify-between md:justify-center items-start w-full gap-4 md:gap-0'>
                        <p className=' font-hanken-grotesk  text-[var(--payperks-body-text-color)] sm:text-[20px] sm:font-[600] sm:leading-[100%] sm:tracking-[0%] md:text-[20px] md:font-[600] text-[16px] font-[600] mt-4 md:mt-0 w-1/3 sm:w-1/2 md:w-auto'>{t("pt_balance")}</p>
                        <div className=' flex flex-row gap-4 items-end justify-end w-2/3 sm:w-1/2 md:w-auto'>
                          <p className=' font-hanken-grotesk  text-[var(--payperks-body-text-color)] sm:text-[72px] sm:font-[600] sm:leading-[100%] sm:tracking-[0%] sm:align-middle sm:mt-[12px] text-[56px] font-[600] tracking-wider '>
                            {pointBalance}
                          </p>
                          <p className=' font-hanken-grotesk  text-[var(--payperks-body-text-color)] md:text-[20px] md:font-[700] sm:text-[12px] sm:font-[700] text-[16px] font-[700] pb-8 sm:pb-0'>
                            {t("points")}
                          </p>
                        </div>

                      </div>
                    </div>
                  </div>
                 
                </div>

              </div>

            </div>
          </>
          :
          <div className=' flex justify-start flex-col'>
           <div className="sm:flex block sm:px-[7%] px-10 w-[100%] justify-between items-center sm:items-start md:items-center">
            <div className='flex justify-between items-start'>
              <div className='flex flex-col sm:gap-0'>
                <div className='flex items-center gap-3 sm:gap-0 mb-[20px]'>
                  <img src={appThemeData.Homepayperks} className='sm:hidden w-[70px] h-[43px]' alt="" />
                  <p className="font-hanken-grotesk font-[600] text-[12px] sm:text-[11px] md:text-[12px] lg:text-[14px] leading-[100%] tracking-[0.1em] uppercase text-[var(--payperks-body-text-color)]">
                    {t('NavbarPerks')}
                  </p>
                </div>
                <div className="font-serif-pro font-[600] text-[var(--payperks-heading-text)] lg:w-[530px] md:w-[280px] sm:w-[220px]
                  w-[200px] 
                lg:text-[32px] md:text-[25px] sm:text-[22px] text-[25px]
                lg:leading-[38px] leading-[33px]">
                    {t('Learn_and_Earn')}
                </div>
                <div className='md:block hidden lg:w-[530px] md:w-[300px] sm:w-[160px] py-4 font-hanken-grotesk text-[var(--payperks-body-text-color)] lg:text-[18px]
                md:text-[16px] sm:text-[13px] font-normal'>
                    {t('When_you_use_your')}</div>
              </div>
            </div>

            {/* Mobile only: Days counter */}
            <div className='sm:hidden relative flex justify-center mt-6'>
              <img src={appThemeData.payperks} className='w-[128px] h-[130px]' alt="PayPerksDays" />
              <div className='absolute top-0 left-0 right-0 bottom-0 flex flex-col justify-center items-center'>
                <span className='text-[56px] text-[#00654F] font-hanken-grotesk leading-[44px] font-[600]'>{payperksDays != null ? payperksDays : 0}</span>
                <p className='mt-2 text-[16px] text-[#00654F] font-hanken-grotesk leading-[19.3px] font-[700]'>{t('days')}</p>
              </div>
            </div>
          </div>

          <div className='sm:flex md:hidden hidden sm:w-[350px] py-4 font-hanken-grotesk text-[#00654F] lg:text-[18px]
            md:text-[16px] sm:text-[13px] font-medium sm:px-[7%]'>
                {t('payPerks_promo_copy')}</div>

          </div>
        }
        <div className={`flex items-center px-10 mt-6 ${isOpted 
          ? 'sm:absolute sm:top-[48px] md:top-[80px] sm:right-[2.5rem] md:right-[64px] sm:mt-0 sm:px-0' 
          : 'sm:justify-between justify-end sm:px-[7%] sm:mt-4'}`}>
          <button className='lg:w-[170px] md:w-[170px] sm:w-[118px] w-full sm:w-auto lg:text-[18px] md:text-[18px] sm:text-[15px] text-[16px] font-hanken-grotesk
             bg-[var(--payperks-button-bg)] rounded-full px-3 py-2 md:py-4 font-[700] text-[var(--payperks-button-text)]'
            onClick={() => { navigate('/PayPerks'); logFirebaseEvents("Home", "get_Start_Clicked", "get_Start_Clicked", "",""); }}>{isOpted ? t('earn_points') : t('Get_Started')}</button>
          {!isOpted && <img src={appThemeData.Homepayperks} className='hidden sm:block lg:w-[139px] lg:h-[84px] md:w-[110px] md:h-[80px] sm:w-[80px] sm:h-[50px]' alt="" />}
        </div>
      </div>

    </DynamicCard>
  )
}

export default PayPerks;